var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShuffle1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.30908 20.9975V17.1524H7.15428",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8275 9.16257C21.7842 14.2505 18.6707 19.2945 13.5873 20.6566C9.69663 21.6991 5.72685 20.2968 3.30908 17.3914",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.17224 12.8372C0.215491 7.7493 3.32906 2.70523 8.41246 1.34314C12.3029 0.30071 16.2724 1.70278 18.6902 4.60781",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6899 1.00266V4.84786H14.8447",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48765 11.517C5.94357 11.4224 5.94357 10.6413 6.48765 10.5467C8.45875 10.2037 10.0265 8.70239 10.4543 6.74797L10.4871 6.59816C10.6048 6.06044 11.3705 6.05709 11.4929 6.59375L11.5327 6.76834C11.9764 8.71356 13.5445 10.2022 15.5102 10.5442C16.057 10.6393 16.057 11.4244 15.5102 11.5195C13.5445 11.8615 11.9764 13.3501 11.5327 15.2953L11.4929 15.4699C11.3705 16.0066 10.6048 16.0032 10.4871 15.4655L10.4543 15.3157C10.0265 13.3613 8.45875 11.8599 6.48765 11.517Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuffle1);
export default __webpack_public_path__ + "static/media/shuffle1.77e03acf2b40e45ba8323904a938d657.svg";
export { ForwardRef as ReactComponent };